<template>
    <img v-img-lazy="src || defaultImage"  @error.once="(e:any) => { e.target.src = defaultImage }" alt="" v-if="lazy">
    <img :src="src || defaultImage"  @error.once="(e:any) => { e.target.src = defaultImage }" alt="" v-else>
</template>

<script lang="ts" setup>
import defaultImage from "@/assets/images/bg_default.png";
const props = defineProps({
    src: {
        type: String,
        default: ""
    },
    lazy: {
        type: Boolean,
        default: false
    }
});



</script>

<style lang="scss" scoped>
img{
    width: 100%;
    height: 100%;
    display: block;
}
</style>